import merge from "lodash/merge";
export class GuideSettings {
    presentation;
    is_dismissible;
    opener_type;
    suspend_mode_settings;
    opener_settings;
    selector_timeout_settings;
    language;
    fillers;
    should_auto_play_first_step;
    tour_expiration_timeout;
    flow_flexibility;
    checkpoint_strategy;
    wander_off_strategy;
    previewImageUrl;
    static DEFAULT_SETTINGS = {
        presentation: "click_tour",
        is_dismissible: false,
        opener_type: "none",
        language: {
            code: "en",
            name: "English",
        },
        suspend_mode_settings: {
            is_enabled: true,
            timeout: 45000,
        },
        selector_timeout_settings: {
            exist_timeout: 3000,
            not_exist_timeout: 3000,
        },
        fillers: {
            resumeTour: {
                title: "I am taking you back",
                content: "Alright, let's jump back in!",
            },
            targetLost: {
                title: "Would you like to come back to the demo?",
                resumeTourButtonText: "Bring me back",
                laterButtonText: "Later",
                avatarScript: "Let me know once you're ready to come back to the demo.",
            },
            targetNotFound: {
                title: "Sorry, there was an error. Can I assist you in any other way?",
                restartButtonText: "Restart the guide",
                contactSupportButtonText: "Contact support",
                avatarScript: "Sorry, there was an error. Can I assist you in any other way?",
            },
        },
        should_auto_play_first_step: true,
        tour_expiration_timeout: 60,
        flow_flexibility: "flexible",
        checkpoint_strategy: "advanced",
        wander_off_strategy: "bring_user_back_flow",
        previewImageUrl: undefined,
    };
    constructor(settings) {
        this.presentation = settings?.presentation ?? GuideSettings.DEFAULT_SETTINGS.presentation;
        this.is_dismissible = settings?.is_dismissible ?? GuideSettings.DEFAULT_SETTINGS.is_dismissible;
        this.opener_type = settings?.opener_type ?? GuideSettings.DEFAULT_SETTINGS.opener_type;
        this.opener_settings = settings?.opener_settings;
        this.language = settings?.language ?? GuideSettings.DEFAULT_SETTINGS.language;
        this.tour_expiration_timeout =
            settings?.tour_expiration_timeout ?? GuideSettings.DEFAULT_SETTINGS.tour_expiration_timeout;
        this.suspend_mode_settings = merge({}, GuideSettings.DEFAULT_SETTINGS.suspend_mode_settings, settings?.suspend_mode_settings);
        this.selector_timeout_settings = merge({}, GuideSettings.DEFAULT_SETTINGS.selector_timeout_settings, settings?.selector_timeout_settings);
        this.fillers = merge({}, GuideSettings.DEFAULT_SETTINGS.fillers, settings?.fillers);
        this.should_auto_play_first_step =
            settings?.should_auto_play_first_step ?? GuideSettings.DEFAULT_SETTINGS.should_auto_play_first_step;
        this.flow_flexibility = settings?.flow_flexibility ?? GuideSettings.DEFAULT_SETTINGS.flow_flexibility;
        this.checkpoint_strategy = settings?.checkpoint_strategy ?? GuideSettings.DEFAULT_SETTINGS.checkpoint_strategy;
        this.wander_off_strategy = settings?.wander_off_strategy ?? GuideSettings.DEFAULT_SETTINGS.wander_off_strategy;
        this.previewImageUrl = settings?.previewImageUrl;
    }
}
export class Guide {
    id;
    organization_id;
    title;
    description;
    created_at;
    updated_at;
    processed_at;
    targeting;
    settings;
    published_at;
    version;
    tour_playback;
    tour_playback_draft;
    avatar_id;
    editor_draft;
    archived_at;
    recording_activated_at;
    recording_session_id;
    processing_failed_at;
    processing_failure_details;
    recording_metadata;
    constructor(guide) {
        this.id = guide.id;
        this.organization_id = guide.organization_id;
        this.title = guide.title;
        this.description = guide.description;
        this.created_at = guide.created_at;
        this.updated_at = guide.updated_at;
        this.processed_at = guide.processed_at;
        this.targeting = guide.targeting;
        this.published_at = guide.published_at;
        this.settings = new GuideSettings(guide.settings);
        this.version = guide.version;
        this.tour_playback = guide.tour_playback;
        this.tour_playback_draft = guide.tour_playback_draft;
        this.avatar_id = guide.avatar_id;
        this.editor_draft = guide.editor_draft;
        this.archived_at = guide.archived_at;
        this.recording_activated_at = guide.recording_activated_at;
        this.recording_session_id = guide.recording_session_id;
        this.processing_failed_at = guide.processing_failed_at;
        this.processing_failure_details = guide.processing_failure_details;
        this.recording_metadata = guide.recording_metadata;
    }
    get isAIGuide() {
        return !!this.recording_activated_at;
    }
    get isPublished() {
        return !!this.published_at && new Date(this.published_at) <= new Date();
    }
    get isArchived() {
        return !!this.archived_at;
    }
    get isProcessing() {
        return !this.processed_at;
    }
    get status() {
        if (this.isPublished) {
            return "published";
        }
        if (this.isArchived) {
            return "archived";
        }
        return "draft";
    }
}
